<div class="card-container">
  @if(showOptions){
  <p-speeddial
    class="dial-button"
    [model]="items"
    [radius]="70"
    type="quarter-circle"
    direction="down-left"
    [buttonProps]="{ severity: 'primary', rounded: true, outlined: true, raised: true }"
    [tooltipOptions]="{ tooltipPosition: 'top' }" />
  }
  <p-card>
    <div class="lesson-card" [style.height]="cardHeight">
      <div class="photo">
        <img [src]="coverUrl" alt="" />
      </div>

      <span class="date">{{ lesson.createdAt | date : 'dd/MM/yyyy' }}</span>

      <div class="description">
        <h1>{{ lesson.title || lesson.metadata?.title || 'No title available' }}</h1>
        <p>{{ lesson.description || lesson.metadata?.description || 'No description available' }}</p>
        <div class="card-footer">
          <div class="status-tags">
            <span class="level-tag">Nivel {{ lesson.level }}</span>
            @if (lesson.taken?.status == 'passed') {
            <p-tag severity="success" value="Tomada" [rounded]="true" />
            } @if (lesson.taken?.status == 'failed') {
            <p-tag severity="danger" value="Fallida" [rounded]="true" />
            } @if (lesson.taken) {
            <p-tag severity="success" value="Tomada 📖" [rounded]="true" />
            } @if (!lesson.metadata?.isPublished) {
            <p-tag severity="danger" value="No publicada" [rounded]="true" />
            }
          </div>

          <div style="position: absolute; bottom: 0px; right: 0px">
            <p-button label="Tomar lección" (onClick)="eventCard(eventType.Select)" severity="primary"> </p-button>
          </div>
        </div>
      </div>
    </div>
  </p-card>
</div>
